import React, { Component, PropTypes } from 'react';

import styled from 'styled-components';

import { media } from '../../../utils/style-utils';

import {
  NitroIcon,
  NitroText,
  NitroGrid,
  NitroGrids,
  NitroHeading,
  NitroParagraph,
  NitroPanel
} from 'nitro-components';

const GRAPH_TITLE = 'Lowest Rated Drivers';

const MetricContainer = styled.div`
width:80%;
`;

const Tile = styled.section`
    display: flex;
    border: 1px solid ${props => props.theme.color.border};
    padding: 20px;
    flex-direction: column;
    text-align: center;
    align-items: center;
    >p{
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
    }
    
`;

const TileOther = styled(Tile)`
    padding: 35px 20px;
`;

const Ranking = styled.p`
    font-size: 21px;
    color: ${props => props.theme.color.negative};
    margin: 0px;
    font-family: ${props => props.theme.font.bold};
`;
const DriverTile = ({ index, driverName }) => {
  return (
    <Tile>
      <Ranking>{index}</Ranking>
      <NitroParagraph noMargin size="3" variant="base1" align="center" bold>
        {driverName}
      </NitroParagraph>
    </Tile>
  );
};

const OtherTile = ({ content }) => {
  return (
    <TileOther>
      <NitroParagraph noMargin size="3" variant="base3" align="center" bold>
        {content}
      </NitroParagraph>
    </TileOther>
  );
};

const DriverSafetySummary = ({ data, error }) => {
  console.log(data);
  const drivers = data.data.slice(0, 5);
  const totalDriver = data.data.length;
  const remainDrivers = totalDriver - drivers.length;
  const warning = <NitroIcon name="red-black-warning" size={22} />;
  return (
    <MetricContainer>

      <NitroHeading
        label={GRAPH_TITLE}
        size="2"
        align="center"
        header
        variant="negative"
        before={warning}
      />
      <NitroGrids>
        {drivers.map((dataObj, index) => {
          return (
            <NitroGrid grid={3} key={index}>
              <DriverTile
                index={index + 1}
                driverName={`${dataObj.DriverFirstName} ${dataObj.DriverSurname}`}
              />
            </NitroGrid>
          );
        })}
        {totalDriver > drivers.length &&
          <NitroGrid grid={3}>
            <OtherTile content={`+${remainDrivers} other drivers`} />
          </NitroGrid>}

      </NitroGrids>
    </MetricContainer>
  );
};

DriverSafetySummary.propTypes = {
  dataType: PropTypes.string,
  exportOptions: PropTypes.object,
  plotOptions: PropTypes.object,
  data: PropTypes.object.isRequired,
  error: PropTypes.bool // TODO .isRequired
};

export default DriverSafetySummary;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/DriverSafetySummary.js